import React from 'react'
import UninstallPage from '../uninstall'

const UninstallPageEn = () => {
    return <UninstallPage languageCode="en" />
}

export default UninstallPageEn
